import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { IPublishedOffersResponse, IResidentOfferContent } from '../../models';
import { offerQueryV2, offersQueryV2, publishedOffersPublicQuery } from '../../queries';

@Injectable()
export class OffersFacade {
  constructor(private apollo: Apollo) {}

  public getOffers(offset: number, limit: number): Observable<IPublishedOffersResponse> {
    return this.apollo
      .query<{ publishedOffersV2: IPublishedOffersResponse }>({
        query: offersQueryV2,
        variables: {
          offset,
          limit,
        },
      })
      .pipe(
        map(response => {
          return response?.data?.publishedOffersV2;
        })
      );
  }

  public getOffer(offerId: string): Observable<IResidentOfferContent> {
    return this.apollo
      .query<{ getOfferV2: IResidentOfferContent }>({
        query: offerQueryV2,
        variables: {
          offerId,
        },
      })
      .pipe(map(response => response?.data?.getOfferV2));
  }

  public getPublishedOffersPublic(
    offset: number,
    limit: number
  ): Observable<IPublishedOffersResponse> {
    return this.apollo
      .query<{ publishedOffersPublic: IPublishedOffersResponse }>({
        query: publishedOffersPublicQuery,
        variables: {
          offset,
          limit,
        },
      })
      .pipe(map(response => response?.data?.publishedOffersPublic));
  }
}
